// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4i-0";
export var eligibilityCardNotEligible = "_4i-1";